import React, { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { genderData } from "../../../../TCPForms/data";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { useSelector } from "react-redux";
import FileUploader from "../../../../TCPForms/formComponents/MobileTowerApplication/FileUploader";
import { Box, IconButton } from "@mui/material";

const SubStep2 = ({ formData, handleSubTabChange }) => {
    const { documents } = useSelector(state => state.formMT);
    const [applicationFlow, DepartmentSelector] = useDepartmentSelector();

    const ownerEntry = {
        name: '',
        fatherOrHusbandName: '',
        mobileNumber: '',
        emailId: '',
        aadhaarNumber: '',
        gender: null,
        correspondenceAddress: {
            applicantName: null,
            applicantGuardianName: null,
            state: "Uttar Pradesh",
            district: null,
            tehsil: null,
            town: null,
            address: "",
            pinno: "",
            type: "CORRESPONDENCE",
        },
        permanentAddress: {
            applicantName: null,
            applicantGuardianName: null,
            state: "Uttar Pradesh",
            district: null,
            tehsil: null,
            town: null,
            address: "",
            pinno: "",
            type: "PERMANENT",
        },
    };
    const { t } = useTranslation();
    const defaultValues = {
        ...formData,
        documents,
        landInfo: {
            ...formData?.landInfo,
            owners: formData?.landInfo?.owners?.length > 0 ? formData?.landInfo?.owners : [ownerEntry]
        },
    };
    useEffect(() => {
        setValue('documents', documents);
    }, [documents]);

    const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
    const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"))

    const morethanOneOwner = formData?.morethanOneOwner === 'yes'

    const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
    const { fields: owners, append: appendOwner, remove: removeOwner } = useFieldArray({
        control,
        name: "landInfo.owners",
    });
    const onSubmit = (data) => {
        handleSubTabChange(2, data)
    }
    if (applicationFlow === null) {
        return <DepartmentSelector />;
    }
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    {owners?.map((owner, index) => (
                        <React.Fragment>
                            <div className="formHeaderContainer">
                                <h2 className="formHeading">{index > 0 ? t("Additional Owner Information") : t("Owner Information")} </h2>
                            </div>
                            <div className="formInputContainer" key={owner.id}>
                                <div className="columnWrapper">
                                    <InputWrapper
                                        label={t("LABEL_ENTER_NAME")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_NAME")}
                                        defaultValue={owner.name}
                                        name={`landInfo.owners[${index}].name`}
                                        type="textInput"
                                        maxLength={30}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern("Name"),
                                                message: "Please enter only letters and spaces",
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_GENDER")}
                                        placeholder="Gender"
                                        defaultValue={owner.gender}
                                        name={`landInfo.owners[${index}].gender`}
                                        type="selectInput"
                                        data={genderData}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "Please select the gender",
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        label={t("LABEL_EMAIL_ID")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_EMAIL_ID")}
                                        defaultValue={owner.emailId}
                                        name={`landInfo.owners[${index}].emailId`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern("Email"),
                                                message: "Please enter valid email id",
                                            },
                                        }}
                                    />
                                    <FileUploader
                                        control={control}
                                        name={`applicantPhoto[${index}]`}
                                        label={t("LABEL_OWNER_PHOTO")}
                                        validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                        isMandatory
                                        required
                                        tab={1}
                                    />
                                    {/* <Grid container spacing={2}>
                                        <Grid item xs={6} md={3}>{t('Communication Address')}</Grid>
                                        </Grid> */}
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_ADDRESS")}
                                        placeholder={t("LABEL_ENTER_ADDRESS")}
                                        defaultValue={owner.correspondenceAddress.address}
                                        name={`landInfo.owners[${index}].correspondenceAddress.address`}
                                        type="textInput"
                                        mandatory
                                        multiLine
                                        maxLength={150}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern('Address'),
                                                message: "Please enter valid Address",
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        data={updistricts}
                                        label={t("LABEL_CITY")}
                                        placeholder={t("LABEL_ENTER_CITY")}
                                        defaultValue={owner.correspondenceAddress.district}
                                        name={`landInfo.owners[${index}].correspondenceAddress.district`}
                                        type="selectInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            }
                                        }}
                                    />
                                </div>
                                <div className="columnWrapper">
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_FATHERS_NAME")}
                                        placeholder={t("LABEL_ENTER_FATHERS_NAME")}
                                        defaultValue={owner.fatherOrHusbandName}
                                        name={`landInfo.owners[${index}].fatherOrHusbandName`}
                                        type="textInput"
                                        maxLength={30}
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern("Name"),
                                                message: "Please enter only letters and spaces",
                                            },
                                        }}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label="Mobile Number(As in Aadhaar)"
                                        placeholder={t("LABEL_ENTER_MOBILE_NO")}
                                        defaultValue={owner.mobileNumber}
                                        name={`landInfo.owners[${index}].mobileNumber`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required",
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern("MobileNo"),
                                                message: "Please enter valid mobile no",
                                            },
                                        }}
                                        maxLength={10}
                                    />
                                    <InputWrapper
                                        label={t("LABEL_AADHAAR_NUMBER")}
                                        control={control}
                                        placeholder={t("LABEL_ENTER_AADHAAR_NO")}
                                        defaultValue={owner.aadhaarNumber}
                                        name={`landInfo.owners[${index}].aadhaarNumber`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            pattern: {
                                                value: Digit.Utils.getPattern("AadharNo"),
                                                message: "Please enter valid Aadhaar no",
                                            },
                                        }}
                                        maxLength={12}
                                    />
                                    <FileUploader
                                        control={control}
                                        name={`signature[${index}]`}
                                        label={t("LABEL_SIGNATURE")}
                                        validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                                        isMandatory
                                        required
                                        tab={1}
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_STATE")}
                                        defaultValue={owner.correspondenceAddress.state || t("LABEL_STATE_UP")}
                                        name={`landInfo.owners[${index}].correspondenceAddress.state`}
                                        type="textInput"
                                        disabled
                                    />
                                    <InputWrapper
                                        control={control}
                                        label={t("LABEL_PINCODE")}
                                        placeholder={t("LABEL_ENTER_PINCODE")}
                                        defaultValue={owner.correspondenceAddress.pinno}
                                        name={`landInfo.owners[${index}].correspondenceAddress.pinno`}
                                        type="textInput"
                                        mandatory
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern('Pincode'),
                                                message: "Please enter valid Pincode",
                                            },
                                        }}
                                        maxLength={6}
                                    />
                                    {morethanOneOwner && <Box sx={{ display: 'flex', gap: '.5rem', justifyContent: 'flex-end' }}>
                                        <IconButton color="primary" aria-label="Add more" onClick={() => appendOwner(ownerEntry)}>
                                            <ButtonWrapper
                                                variant="contained"
                                                size="medium"
                                                label="Add"
                                                color="primary"
                                                sx={{ backgroundColor: '#157CB3' }}
                                            />
                                        </IconButton>
                                        {owners.length > 0 && index > 0 && (
                                            <IconButton color="error" aria-label="Delete" onClick={() => removeOwner(index)}>
                                                <ButtonWrapper
                                                variant="contained"
                                                size="medium"
                                                label="Remove"
                                                color="secondary"
                                            />
                                            </IconButton>
                                        )}
                                    </Box>}
                                </div>
                                <br />
                            </div>
                        </React.Fragment>
                    ))}
                </div>
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => handleSubTabChange(0)}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            sx={{ backgroundColor: '#157CB3' }}
                        />
                    </div>
                </div>
            </form>

        </section>
    );
};

export default SubStep2;
